<template>
  <div>
    <div>
      <Titulo :titulo="'Informes - '+routeName" />
    </div>
    <!-- coger el parametro que se envio por la ruta -->
    <!-- {{$route.params.id}} -->
    <div class="margin-informes">
      <h4 class="color-secundary">Informe de estado de reclamación</h4>
      <br />

      <!--
        @props
            data: Array,            required: true
            pagination: boolean,    required: false
            perPage: Number,        required: false
            SetectFiltro: Array     required: false
            filtro: boolean         required: false
      -->

      <div class="col text-center" v-if="dataLength < 1">
        No se encontraron datos para mostrar
      </div>
      <div class="col" v-for="chart in data" :key="chart.convenio">
        <h4 style="padding-top: 20px" v-if="chart.modelo == 1">
          Respaldo FGA
        </h4>
        <h4 style="padding-top: 20px" v-else>Cobertura Integral</h4>
        <p style="font-style: oblique;">
          {{ "Fecha limite pago: " + chart.fecha_limite_pago }}
        </p>
        <Charts :data="chart" :labels="chart.labels" :series="chart.series" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import SelectNovedad from "@/data/SelectQueEsNovedad.json";
import SelectTipoNovedad from "@/data/SelectTipoNovedad.json";

export default {
  name: "SubirInformes",
  data() {
    return {
      SelectNovedad: SelectNovedad,
      SelectTipoNovedad: SelectTipoNovedad,
      selectQueEsNovedad: "",
      selectTipoNovedad: ""
    };
  },
  components: {
    Titulo: () => import("@/containers/layout/Titulo.vue"),
    TableComponent: () => import("@/components/table/TableComponent"),
    TableColumn: () => import("@/components/table/TableColumn"),
    Charts: () => import("@/components/Charts")
  },
  computed: {
    ...mapGetters({
      TablaVerProducto: "pages/TablaVerProducto",
      SelectFiltroTabla: "pages/SelectFiltroTabla",
      loading: "loading"
    }),
    dataLength() {
      return this.$store.getters["pages/dataInformes"].datos.total_operaciones;
    },
    data() {
      return this.$store.getters["pages/dataInformes"].datos;
    },
    routeName() {
      return this.$router.currentRoute.name;
    },
  },
  methods: {
    clickEvent() {},
  },
  mounted() {
    this.$store.dispatch("pages/fetch", {
      endpoint: "informes/estado_reclamacion",
      params: {
        //fecha_limite_pago_inicial: "2020-05-01", // this.$moment(new Date()).format("YYYY-MM-DD")
      },
    });
  },
};
</script>
